import _ from 'lodash';

import { createApiReducer } from 'src/api';

import {
  FETCH_SCHEDULED_TASKS_START,
  FETCH_SCHEDULED_TASKS_SUCCESS,
  FETCH_SCHEDULED_TASKS_FAILURE,
  ADD_SCHEDULED_TASKS_START,
  ADD_SCHEDULED_TASKS_SUCCESS,
  ADD_SCHEDULED_TASKS_FAILURE,
  UPDATE_SCHEDULED_TASK_START,
  UPDATE_SCHEDULED_TASK_SUCCESS,
  UPDATE_SCHEDULED_TASK_FAILURE,
  DELETE_SCHEDULED_TASK_START,
  DELETE_SCHEDULED_TASK_SUCCESS,
  DELETE_SCHEDULED_TASK_FAILURE,
} from './actions';

export const transformTask = response => {
  return {
    fiId: response.engine_task_fi_id,
    taskEmail: response.engine_task_email,
    taskLastStart: response.engine_task_last_start,
    taskTypeId: response.engine_task_type_id,
    taskFrequencyId: response.engine_task_frequency_id,
    taskId: response.engine_task_scheduler_id_id,
  };
};

const updateItem = (list, key, value, newItem) => {
  return list.map(item => {
    if (item[key] === value) {
      return newItem;
    }
    return item;
  });
};

export const transformTasks = response => {
  return response.map(t => transformTask(t));
};

// FETCH
const fetchTaskReducers = createApiReducer(
  [
    FETCH_SCHEDULED_TASKS_START,
    FETCH_SCHEDULED_TASKS_SUCCESS,
    FETCH_SCHEDULED_TASKS_FAILURE,
  ],
  // transformTasks,
  (payload, state) => {
    const transformedResponse = transformTasks(payload);
    return {
      ...state.data,
      tasks: transformedResponse,
    };
  },
  error => _.get(error, 'payload.response', 'unknown error')
);

// ADD
const addTaskReducer = createApiReducer(
  [
    ADD_SCHEDULED_TASKS_START,
    ADD_SCHEDULED_TASKS_SUCCESS,
    ADD_SCHEDULED_TASKS_FAILURE,
  ],
  (payload, state) => {
    return {
      ...state.data,
      tasks: [...state.data.tasks, transformTask(payload)],
    };
  },
  error => transformTask(_.get(error, 'payload.response', {}))
);

const updateTasks = (payload, state) => {
  const newTask = transformTask(payload);

  return {
    ...state.data,
    tasks: updateItem(state.data.tasks, 'id', newTask.id, newTask),
  };
};

// UPDATE
const updateTaskReducer = createApiReducer(
  [
    UPDATE_SCHEDULED_TASK_START,
    UPDATE_SCHEDULED_TASK_SUCCESS,
    UPDATE_SCHEDULED_TASK_FAILURE,
  ],
  updateTasks,
  error => transformTask(_.get(error, 'payload.response', {}))
);

// DELETE
const deleteTaskReducer = createApiReducer(
  [
    DELETE_SCHEDULED_TASK_START,
    DELETE_SCHEDULED_TASK_SUCCESS,
    DELETE_SCHEDULED_TASK_FAILURE,
  ],
  (payload, state) => {
    return {
      ...state.data,
      tasks: state.data.tasks.filter(task => task.id !== payload.id),
    };
  },
  error => transformTask(_.get(error, 'payload.response', {}))
);

export const reducers = [
  fetchTaskReducers,
  addTaskReducer,
  updateTaskReducer,
  deleteTaskReducer,
];
